import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 18,
	height: 21,
	viewBox: "0 0 18 21",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			fill: "currentColor",
			fillRule: "nonzero",
			children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
				d: "M5.845 26.25h-1.58c-.26 0-.474-.21-.474-.469V24.22c0-.258.213-.469.474-.469h1.58c.26 0 .474.21.474.469v1.562c0 .258-.214.469-.474.469zm4.265-.469V24.22c0-.258-.213-.469-.474-.469h-1.58c-.26 0-.474.21-.474.469v1.562c0 .258.214.469.474.469h1.58c.26 0 .474-.21.474-.469zm3.791 0V24.22c0-.258-.213-.469-.474-.469h-1.58c-.26 0-.473.21-.473.469v1.562c0 .258.213.469.474.469h1.58c.26 0 .473-.21.473-.469zm-3.791 3.75V27.97c0-.258-.213-.469-.474-.469h-1.58c-.26 0-.474.21-.474.469v1.562c0 .258.214.469.474.469h1.58c.26 0 .474-.21.474-.469zm-3.791 0V27.97c0-.258-.214-.469-.474-.469h-1.58c-.26 0-.474.21-.474.469v1.562c0 .258.213.469.474.469h1.58c.26 0 .474-.21.474-.469zm7.582 0V27.97c0-.258-.213-.469-.474-.469h-1.58c-.26 0-.473.21-.473.469v1.562c0 .258.213.469.474.469h1.58c.26 0 .473-.21.473-.469zm3.791-10.156v13.75c0 1.035-.849 1.875-1.895 1.875H1.896C.849 35 0 34.16 0 33.125v-13.75C0 18.34.85 17.5 1.896 17.5H3.79v-2.031c0-.258.213-.469.474-.469h1.58c.26 0 .474.21.474.469V17.5h5.055v-2.031c0-.258.213-.469.474-.469h1.58c.26 0 .473.21.473.469V17.5h1.896c1.046 0 1.895.84 1.895 1.875zm-1.895 13.516V21.25H1.896v11.64c0 .13.106.235.237.235H15.56c.13 0 .237-.105.237-.234z",
				transform: "translate(-271.000000, -314.000000) translate(239.000000, 199.750000) translate(32.000000, 100.000000)"
			}) }) })
		})
	})
});
export default SvgCalendarIcon;
